var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.steps.length)?_c('div',{staticClass:"approval-stepper"},_vm._l((_vm.steps),function(step,index){return _c('div',{key:step.key,staticClass:"approval-stepper__item",class:{
      'is-active': index === _vm.activeIndex,
      'is-done': index < _vm.activeIndex,
      'is-rejected': _vm.isRejected && index === _vm.activeIndex,
    }},[_c('div',{staticClass:"approval-stepper__marker"},[_vm._v(_vm._s(index + 1))]),_c('span',{staticClass:"approval-stepper__label"},[_vm._v(_vm._s(step.label))])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }